export default __webpack_public_path__ + "a7a2fd09daacc8b97453713f51a4ba38.png";